import { gql } from 'apollo-angular';
import { TypedDocumentNode } from '@apollo/client';
import { SSOQueryResult } from '@ui/shared/model';

export interface ResetPasswordResponse {
  resetPassword: {
    status: number;
    statusText: string;
  };
}

export const userUpdateLastLogin = gql`
  mutation {
    updateLastLogin {
      statusText
    }
  }
`;

export const ssoQuery: TypedDocumentNode<SSOQueryResult> = gql`
  query sso($email: String, $redirectUri: String!, $loginMethod: String) {
    sso(
      input: {
        email: $email
        redirectUri: $redirectUri
        loginMethod: $loginMethod
      }
    ) {
      baseUrl
      clientId
      realm
    }
  }
`;

export const requestPasswordResetMutation = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email) {
      token
    }
  }
`;

export const resetPasswordMutation: TypedDocumentNode<ResetPasswordResponse> = gql`
  mutation resetPassword(
    $password: String!
    $confirmedPassword: String!
    $token: String!
  ) {
    resetPassword(
      password: $password
      confirmedPassword: $confirmedPassword
      token: $token
    ) {
      status
      statusText
    }
  }
`;
